import React from 'react';

/**
 * A stylized dash symbol used in tables to indicate the column has no value.
 */
const NoColumnValue = () => <span className="no-column-value">&mdash;</span>;

export default NoColumnValue;
